import * as angular from 'angular';

import { Log } from '../../models';
import { IRequestService } from '../../services';

export interface ILogService {
    getAll(): angular.IPromise<any>;
    getAll(force: boolean): angular.IPromise<any>;
    getAllV1(): angular.IPromise<any>;
    getAllService(): angular.IPromise<any>;
    getAllAPI(): angular.IPromise<any>;
    getAllAPI(force: boolean): angular.IPromise<Log[]>;
    getBetween(beginDate: Date | string, endDate: Date | string): angular.IPromise<any>;
    getBetweenV1(beginDate: Date | string, endDate: Date | string): angular.IPromise<any>;
    getBetweenService(beginDate: Date | string, endDate: Date | string): angular.IPromise<any>;
    getBetweenAPI(beginDate: Date | string, endDate: Date | string): angular.IPromise<any>;
    download(): angular.IPromise<any>;
}

export class LogService implements ILogService {
    static serviceId = 'logService';

    static $inject = ['$q', 'requestService'];

    constructor(
        private _$q: angular.IQService,
        private _requestService: IRequestService) {
    }

    getAll(): angular.IPromise<any>;
    getAll(force: boolean): angular.IPromise<any>;
    getAll(force: boolean = false): angular.IPromise<any> {
        const url = this._requestService.getUrlV1() + 'log/';
        if (force) {
            this._requestService.cleanCache(url);
        }
        return this._requestService.get(url);
    }

    getAllV1(): angular.IPromise<any> {
        const url = this._requestService.getUrlV1() + 'log/WideV1/';
        return this._requestService.get(url);
    }

    getAllService(): angular.IPromise<any> {
        const url = this._requestService.getUrlV1() + 'log/Service/';
        return this._requestService.get(url);
    }

    getAllAPI(force: boolean = false): angular.IPromise<any> {
        const url = this._requestService.getUrlV1() + 'log/WebAPI/';
        if (force) {
            this._requestService.cleanCache(url);
        }
        return this._requestService.get(url);
    }

    getBetween(beginDate: Date | string, endDate: Date | string): angular.IPromise<any> {
        const url = this._requestService.getUrlV1() + 'log/'
            + '?beginDateTime=' + beginDate
            + '&endDateTime=' + endDate;
        return this._requestService.get(url);
    }

    getBetweenV1(beginDate: Date | string, endDate: Date | string): angular.IPromise<any> {
        const url = this._requestService.getUrlV1() + 'log/WideV1/'
            + '?beginDateTime=' + beginDate
            + '&endDateTime=' + endDate;
        return this._requestService.get(url);
    }

    getBetweenService(beginDate: Date | string, endDate: Date | string): angular.IPromise<any> {
        const url = this._requestService.getUrlV1() + 'log/Service/'
            + '?beginDateTime=' + beginDate
            + '&endDateTime=' + endDate;
        return this._requestService.get(url);
    }

    getBetweenAPI(beginDate: Date | string, endDate: Date | string): angular.IPromise<any> {
        const url = this._requestService.getUrlV1() + 'log/WebAPI/'
            + '?beginDateTime=' + beginDate
            + '&endDateTime=' + endDate;
        return this._requestService.get(url);
    }

    download(): angular.IPromise<any> {
        const url = this._requestService.getUrlV1() + 'log/Download/';
        this._requestService.cleanCache(url);
        return this._requestService.get(url)
            .then((d) => {
                return this._requestService.getApiUrl() + d;
            });
    }
}
